<div class="p-4 md:p-6 max-w-6xl mx-auto">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-6">
    <div class="flex items-center gap-3">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">account_balance</mat-icon>
      <h1 class="text-xl md:text-2xl font-bold text-gray-800">Bancos Activos VES</h1>
      <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full">
        {{ cuentas.length }} registros
      </span>
    </div>
    <button type="button" (click)="openCreateDialog()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
      Registrar cuenta
    </button>
  </div>
  <!-- Badge mobile -->
  <span class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-4">
    {{ cuentas.length }} registros
  </span>

  <!-- Tabla Desktop -->
  <div class="hidden lg:block bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div class="overflow-x-auto">
      <table mat-table [dataSource]="cuentas" class="w-full">

        <ng-container matColumnDef="titular">
          <th mat-header-cell *matHeaderCellDef>Titular</th>
          <td mat-cell *matCellDef="let cuenta">
            <span class="text-xs font-semibold text-gray-800">{{ cuenta.nombreTitular }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="rifCedula">
          <th mat-header-cell *matHeaderCellDef>RIF / Cédula</th>
          <td mat-cell *matCellDef="let cuenta">
            <span class="text-xs font-mono text-gray-700">{{ cuenta.rifCedula }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="banco">
          <th mat-header-cell *matHeaderCellDef>Banco</th>
          <td mat-cell *matCellDef="let cuenta">
            <span class="text-xs text-gray-700">{{ cuenta.banco }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="tipoCuenta">
          <th mat-header-cell *matHeaderCellDef>Tipo Cuenta</th>
          <td mat-cell *matCellDef="let cuenta">
            <span class="text-xs text-gray-700" style="text-transform: capitalize;">{{ cuenta.tipoCuenta }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="numeroCuenta">
          <th mat-header-cell *matHeaderCellDef>Número Cuenta</th>
          <td mat-cell *matCellDef="let cuenta">
            <span class="text-xs font-mono text-gray-700">{{ cuenta.numeroCuenta }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef style="min-width: 160px; max-width: 200px; text-align: center;">Disponibilidad</th>
          <td mat-cell *matCellDef="let cuenta" style="min-width: 160px; max-width: 200px; text-align: center;">
            <mat-slide-toggle
              [checked]="cuenta.activo === 1"
              (change)="confirmToggleActive(cuenta)"
              color="primary">
              {{ cuenta.activo === 1 ? 'Activa' : 'Inactiva' }}
            </mat-slide-toggle>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center py-4 text-sm text-gray-400" [attr.colspan]="displayedColumns.length">
            No hay cuentas bancarias registradas
          </td>
        </tr>
      </table>
    </div>
  </div>

  <!-- Cards Mobile -->
  <div class="lg:hidden space-y-3">
    <div *ngIf="cuentas.length === 0" class="text-center text-sm text-gray-400 py-8">
      No hay cuentas bancarias registradas
    </div>
    <div *ngFor="let cuenta of cuentas; let i = index"
      class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
      [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

      <div class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleCard(i)"
        [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <span class="px-2 py-0.5 text-xs font-bold rounded-full shrink-0"
            [style.background]="cuenta.activo === 1 ? '#16a34a' : '#6b7280'"
            style="color: #fff;">
            {{ cuenta.activo === 1 ? 'Activa' : 'Inactiva' }}
          </span>
          <span class="text-xs font-semibold text-gray-800 truncate">{{ cuenta.nombreTitular }}</span>
          <span class="text-xs text-gray-500 shrink-0">{{ cuenta.banco }}</span>
        </div>
        <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
          [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
        <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">RIF / Cédula</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ cuenta.rifCedula }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo Cuenta</span>
            <p class="text-gray-700 font-medium mt-0.5" style="text-transform: capitalize;">{{ cuenta.tipoCuenta }}</p>
          </div>
          <div class="col-span-2">
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Número Cuenta</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ cuenta.numeroCuenta }}</p>
          </div>
        </div>
        <div class="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
          <span class="text-xs font-semibold text-gray-500">Disponibilidad</span>
          <mat-slide-toggle
            [checked]="cuenta.activo === 1"
            (change)="confirmToggleActive(cuenta)"
            color="primary">
            {{ cuenta.activo === 1 ? 'Activa' : 'Inactiva' }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>
</div>
